import { z } from 'zod';
import { appCodeSchema, entityProfileSchema, entityRoleSchema, entitySlugSchema, roleGrantSchema } from '@xiltrion/identidad';
export const EntityStatus = { ACTIVE: 'ACTIVE', SUSPENDED: 'SUSPENDED', ARCHIVED: 'ARCHIVED' };
export const ENTITY_STATUS_LABEL = { ACTIVE: 'Activa', SUSPENDED: 'Suspendida', ARCHIVED: 'Archivada' };
export const ProvisioningStatus = { PENDING: 'PENDING', PROVISIONED: 'PROVISIONED', FAILED: 'FAILED', MANUAL: 'MANUAL' };
export const entityCreateSchema = z.object({
    slug: entitySlugSchema,
    name: z.string().trim().min(1).max(200),
    profile: entityProfileSchema.default('COMPANY'),
    nit: z.string().trim().max(20).nullable().optional(),
    /** Dónde viven sus datos en las apps (`data_locations`). */
    dataLocation: z.string().regex(/^[a-z][a-z0-9-]{1,30}$/).default('default'),
    /** Administrador inicial: recibe invitación y queda ADMIN de la entidad. */
    admin: z.object({ email: z.string().trim().email(), displayName: z.string().trim().min(1).max(160) }),
    /** Apps que se habilitan al crearla (se aprovisionan en cada app). */
    apps: z.array(appCodeSchema).default([]),
});
export const entityUpdateSchema = z.object({
    name: z.string().trim().min(1).max(200).optional(),
    profile: entityProfileSchema.optional(),
    nit: z.string().trim().max(20).nullable().optional(),
    status: z.enum(['ACTIVE', 'SUSPENDED', 'ARCHIVED']).optional(),
    dataLocation: z.string().regex(/^[a-z][a-z0-9-]{1,30}$/).optional(),
});
export const dataLocationSchema = z.object({
    code: z.string().trim().regex(/^[a-z][a-z0-9-]{1,30}$/, 'Código inválido: minúsculas, números y guiones'),
    name: z.string().trim().min(1).max(80),
    description: z.string().trim().max(300).default(''),
});
export const entityAppToggleSchema = z.object({ enabled: z.boolean(), /** No llamar a la app (el tenant ya existe o se crea a mano). */ manual: z.boolean().default(false) });
export const entityModulesSchema = z.object({ modules: z.array(z.string()) });
export const memberCreateSchema = z.object({
    email: z.string().trim().email(),
    displayName: z.string().trim().min(1).max(160),
    jobTitle: z.string().trim().max(160).nullable().optional(),
    role: entityRoleSchema.default('MEMBER'),
    apps: z.array(appCodeSchema).default([]),
    /** Roles por app (§3.9); sin entrada para una app con catálogo, los roles por defecto. */
    appRoles: z.record(z.array(roleGrantSchema)).default({}),
});
/** Acceso y roles de una persona en una app. */
export const memberAppSchema = z.object({ access: z.boolean(), roles: z.array(roleGrantSchema).default([]) });
export const memberUpdateSchema = z.object({
    role: entityRoleSchema.optional(),
    status: z.enum(['ACTIVE', 'INACTIVE']).optional(),
    jobTitle: z.string().trim().max(160).nullable().optional(),
    apps: z.array(appCodeSchema).optional(),
});
/** Importación por CSV (consola): filas ya separadas por la web. */
export const membersImportSchema = z.object({
    rows: z.array(z.object({ email: z.string().trim().email(), displayName: z.string().trim().min(1).max(160), jobTitle: z.string().trim().max(160).optional(), role: entityRoleSchema.default('MEMBER') })).min(1).max(5000),
    apps: z.array(appCodeSchema).default([]),
    invite: z.boolean().default(true),
});
export const identityProviderSchema = z.object({
    kind: z.enum(['ENTRA', 'GOOGLE', 'OIDC']),
    name: z.string().trim().min(1).max(80),
    issuer: z.string().url(),
    clientId: z.string().trim().min(1),
    /** Al editar, vacío conserva el actual. */
    clientSecret: z.string().optional(),
    emailDomains: z.array(z.string().trim().toLowerCase().regex(/^[a-z0-9.-]+\.[a-z]{2,}$/)).min(1),
    autoProvision: z.boolean().default(false),
    defaultApps: z.array(appCodeSchema).default([]),
    enabled: z.boolean().default(true),
});
/** Issuers conocidos para rellenar el formulario. */
export const IDP_PRESETS = {
    ENTRA: { label: 'Microsoft Entra ID', issuer: (t) => `https://login.microsoftonline.com/${t ?? '{tenant-id}'}/v2.0`, hint: 'Registra una app en Entra con redirect URI = <suite>/api/v1/auth/federated/callback' },
    GOOGLE: { label: 'Google Workspace', issuer: () => 'https://accounts.google.com', hint: 'Crea un cliente OAuth web en Google Cloud con redirect URI = <suite>/api/v1/auth/federated/callback' },
};
//# sourceMappingURL=entities.js.map